import React from 'react';
import { Grid, Header, Container, Input, Image } from 'semantic-ui-react';

import { renderLoadingMsg } from '../helper/helper.js'
import { base } from '../helper/base-helper.js';
import SearchRsltArea from './SearchRsltArea.js';
import logo from '../mediaData/actioncy-io-logo.png'


class SearchScrn extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: true,
      channels: {},
      actions: {},
      query: '',
      queryResult: {}
      }
  }

  componentWillMount() {
    const artificialEventObj = {
        target: {
        value: this.props.urlQuery
      }
    }
    let updtStateObj = {channels:{}, actions:{}};
    const channelFtch = base.fetch(`/channels`,{
      context: this
    });
    const actionFtch = base.fetch(`/actions`,{
      context: this
    });
    Promise.all([channelFtch, actionFtch]).then(data => {
      const channels = data[0];
      const actions = data[1];

      // only published items are put to state
      for(let prop in channels) {
        if(channels[prop].published)
        updtStateObj.channels[prop] = {...channels[prop]}
      }
      for(let prop in actions) {
        if(actions[prop].published)
        updtStateObj.actions[prop] = {...actions[prop]}
      }
      this.setState({
        ...updtStateObj,
        loading: false
      });

      if (this.props.urlQuery)
      this.handleSearchChange(artificialEventObj)
    }).catch(error => {
      console.error(error);
    });
  }


  componentWillUnmount() {
    this.setState = () => {};
  }

  handleSearchChange = e =>  {
    let tempSrchResObj = {
      channels: {},
      actions: {}
    };
    const queryVal = e.target.value;

    const re = new RegExp(queryVal, 'ig');
    const chansToTest = this.state.channels;
    const acyToTest = this.state.actions;

    //get filtered by name channels & actions
    //TODO check refactoring using map and filter -> egghead.io video
    Object.keys(this.state.channels).forEach((el) => {
      const string = JSON.stringify(chansToTest[el]['name']);
      const queryIncluded = string.match(re);

      if(queryIncluded && queryVal)
        tempSrchResObj.channels[el] = chansToTest[el];
    })

    Object.keys(this.state.actions).forEach((el) => {
      const string = JSON.stringify(acyToTest[el]['name']);
      const queryIncluded = string.match(re);

      if(queryIncluded && queryVal)
        tempSrchResObj.actions[el] = acyToTest[el];
    })

    //set query information to display in search bar & resultObj for SearchRsltArea
    this.setState({
      query: queryVal,
      queryResult: tempSrchResObj
    });
  };

  render() {
    const archiveHeader = () =>
      <Header className='searchRsltAreaIntro'>
        actioncy.io`s Online Marketing & Publishing archive:
      </Header>

    return (
      <Container className='searchScrn'>
        <Grid centered relaxed stackable columns={1} className={'container'}>
          <Grid.Row>
            <Image src={logo} className="logo" />
          </Grid.Row>
          <Grid.Row columns={3}>
            <Header as='h1'>
              Marketing Requirements Search
              <Header.Subheader>
                This is a repository of marketing requirements and how to
                articles. <br /> <br />
                Just browse the list below or search:
              </Header.Subheader>
            </Header>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Input
                className='icon searchBar fluid'
                icon='search'
                placeholder='Start typing...'
                value={this.state.query}
                onChange={this.handleSearchChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row >
            {
              (!this.state.query.length) ? archiveHeader() : ''
            }
          </Grid.Row>
        </Grid>
        {(this.state.loading)
          ? renderLoadingMsg()
          : <SearchRsltArea { ...this.state } /> }
      </Container>
    );
  }
}
export default SearchScrn;



// WEBPACK FOOTER //
// ./src/components/SearchScrn.js